/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Line_ItemsInputs */

const en_orders_no_line_items = /** @type {(inputs: Orders_No_Line_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No line items available.`)
};

const es_orders_no_line_items = /** @type {(inputs: Orders_No_Line_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay lineas disponibles.`)
};

/**
* | output |
* | --- |
* | "No line items available." |
*
* @param {Orders_No_Line_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_line_items = /** @type {((inputs?: Orders_No_Line_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Line_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_line_items(inputs)
	return es_orders_no_line_items(inputs)
});